import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config} from '../../shared';
import {
  MultipleEventExpensesReportsContainerModel,
  SingleEventExpensesReportsContainerModel, StatisticsEventExpensesReportsContainerModel
} from '../../../../../../models/aggregates/cms/event-calendar';
import {Observable} from 'rxjs';

export class SingleEventRequestBody {
  claim_statuses: string[] = [];
  claim_types: string[] = [];
}

export class MultipleEventRequestBody {
  claim_statuses: string[] = [];
  claim_types: string[] = [];
  calendar_event_hdr_guids: string[] = [];
  event_pic_employee_hdr_guids: string[] = [];
}


@Injectable({providedIn: 'root'})

export class EventExpensesReportsService extends BaseApiTemplateService<SingleEventExpensesReportsContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'reports/event-expenses-reports/single-event/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'reports/event-expenses-reports/single-event/backoffice-ep';
    this.httpClient = http;
  }

  getSingleEventReport(body: SingleEventRequestBody, eventGuid: string, apiVisa: ApiVisa): Observable<ApiResponseModel<SingleEventExpensesReportsContainerModel>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/reports/event-expenses-reports/single-event/backoffice-ep/' + eventGuid;
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/reports/event-expenses-reports/single-event/backoffice-ep/' + eventGuid;
    }

    return this.httpClient.post<ApiResponseModel<SingleEventExpensesReportsContainerModel>>(apiUrl, body, this.getHttpHeader(apiVisa));
  }

  getSingleEventStatisticsReport(body: SingleEventRequestBody, eventGuid: string, apiVisa: ApiVisa): Observable<ApiResponseModel<StatisticsEventExpensesReportsContainerModel>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/reports/event-expenses-reports/single-event/statistics/backoffice-ep/' + eventGuid;
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/reports/event-expenses-reports/single-event/statistics/backoffice-ep/' + eventGuid;
    }

    return this.httpClient.post<ApiResponseModel<StatisticsEventExpensesReportsContainerModel>>(apiUrl, body, this.getHttpHeader(apiVisa));
  }

  getMultipleEventReport(body: MultipleEventRequestBody, apiVisa: ApiVisa): Observable<ApiResponseModel<MultipleEventExpensesReportsContainerModel>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/reports/event-expenses-reports/multiple-events/backoffice-ep';
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/reports/event-expenses-reports/multiple-events/backoffice-ep';
    }

    return this.httpClient.post<ApiResponseModel<MultipleEventExpensesReportsContainerModel>>(apiUrl, body, this.getHttpHeader(apiVisa));
  }

  getMultipleEventStatisticsReport(body: MultipleEventRequestBody, apiVisa: ApiVisa): Observable<ApiResponseModel<StatisticsEventExpensesReportsContainerModel>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/reports/event-expenses-reports/multiple-events/statistics/backoffice-ep';
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/reports/event-expenses-reports/multiple-events/statistics/backoffice-ep';
    }

    return this.httpClient.post<ApiResponseModel<StatisticsEventExpensesReportsContainerModel>>(apiUrl, body, this.getHttpHeader(apiVisa));
  }
}
